import classNames from 'classnames';
import { FC, useMemo } from 'react';
import type { GreekLine } from 'state/quotes/details/details.model';

export const FxSpot: FC<{ greekLine: GreekLine | null; isObsolete?: boolean }> = ({ greekLine, isObsolete }) => {
  const formatedValue = useMemo(() => {
    if (typeof greekLine?.value === 'number') {
      return greekLine?.value.toFixed(4);
    }
    return `${greekLine?.value}`;
  }, [greekLine]);

  if (greekLine === null) {
    return null;
  }

  return (
    <div
      className={classNames(
        {
          'text-decoration-line-through': isObsolete,
        },
        'align-middle text-large',
      )}
      data-e2e="fx-spot"
    >
      {`${greekLine.name} ${greekLine.reference} : ${formatedValue}`}
    </div>
  );
};

FxSpot.displayName = 'FxSpot';
